import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Seo } from "@/components/common/Seo";
import { IMAGES } from "@/content/site";

export default function Insights() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/api/insights").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-insights">
      <Seo title="Insights | Azeka Global" description="Perspectives on international sourcing, trade and market access from Azeka Global (AZEKA GLOBAL TRADE FZCO)." path="/insights" />
      <PageHero eyebrow="Insights" title="Perspectives on international trade" lead="Views on sourcing, compliance and market access across regulated and consumer goods." image={IMAGES.portDusk} />
      <section className="container-x py-16 lg:py-24">
        {loading ? (
          <p className="text-ink-muted">Loading…</p>
        ) : items.length === 0 ? (
          <p className="text-ink-muted">No insights have been published yet. Please check back soon.</p>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {items.map((it, idx) => (
              <Reveal key={it.slug} delay={idx * 0.06}>
                <Link to={`/insights/${it.slug}`} data-testid={`insight-card-${it.slug}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-azeka-navy/10">
                  {it.cover_image ? (
                    <div className="h-48 overflow-hidden">
                      <img src={it.cover_image} loading="lazy" decoding="async" alt={it.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    </div>
                  ) : null}
                  <div className="flex flex-1 flex-col p-6">
                    <h2 className="text-lg font-semibold text-ink-heading">{it.title}</h2>
                    <p className="mt-2 text-sm leading-relaxed text-ink-muted">{it.excerpt}</p>
                    {it.author ? <p className="mt-4 text-xs text-ink-muted">By {it.author}</p> : null}
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
